"use strict";

import React from "react";
import ReactDOM from "react-dom";

import lang from "./../../lang";
import api from "./../../api";
import Dialog from "./../Dialog";
import Button from "./../Button";
import Input from "./../Input";
import ProgressBar from "./../ProgressBar";

import "./LoginDialog.css";

import {types as fluxTypes} from "vwa/flux";

export default class LoginDialog extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			error: ""
		};
	}
	
	setError(error) {
		this.setState({error});
	}
	
	componentDidMount() {
		this.focusToUsernameInput();
	}
	
	componentDidUpdate(nextProps) {
		this.focusToUsernameInput();
	}
	
	clearInputs() {
		const usernameInput = ReactDOM.findDOMNode(this.refs.username);
		const passwordInput = ReactDOM.findDOMNode(this.refs.password);
		usernameInput.value = "";
		passwordInput.value = "";
	}
		
	focusToUsernameInput() {
		const usernameInput = ReactDOM.findDOMNode(this.refs.username);
		setTimeout(() => usernameInput.focus(), 100);
	}
	
	isValid() {
		const usernameInput = ReactDOM.findDOMNode(this.refs.username);
		const passwordInput = ReactDOM.findDOMNode(this.refs.password);
		
		if (usernameInput.value && passwordInput.value)
			return true;
		return false;
	}
	
	keyUpHandler(evt) {
		if (evt.keyCode == 13) {
			this.submit();
		}
	}
	
	submit() {
		if (this.isValid()) {
			const usernameInput = ReactDOM.findDOMNode(this.refs.username);
			const passwordInput = ReactDOM.findDOMNode(this.refs.password);
			
			this.props.onSubmit(usernameInput.value, passwordInput.value);
		}
	}
	
	render() {
		return (
			<Dialog shown={this.props.shown} className="LoginDialog">
				<header>
					<h1>{lang.LOGIN}</h1>
				</header>
				
				<div>
					<div>
						<label id="errorMsg">{this.state.error}</label>
						<Input
							ref="username"
							placeholder={lang._USERNAME}
							onKeyUp={evt => this.keyUpHandler(evt)}
						/>
						<Input
							ref="password"
							type="password"
							placeholder={lang._PASSWORD}
							onKeyUp={evt => this.keyUpHandler(evt)}
						/>
					</div>
				</div>
				
				<footer>
					<Button
						className="Red"
						onClick={_ => this.submit()}
					>
						{lang.LOGIN}
					</Button>
				</footer>
				
			</Dialog>
		);
	}
	
}

LoginDialog.propTypes = {
	shown: React.PropTypes.bool,
	errorMsg: React.PropTypes.string,
	onSubmit: React.PropTypes.func
};

LoginDialog.defaultProps = {
	shown: false,
	errorMsg: "",
	onSubmit: (username, password) => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/LoginDialog/LoginDialog.jsx